import Vue from 'vue'
import store from 'store'
import select from 'dom-select'
import on from 'dom-event'
import { method } from 'lodash'

export default (el) => Promise.all([
  enqueueModule('product-card.vue')
]).then(() => new Vue({
  el,
  store,
  data () {
    return {
      filterOpen: false,
      sortOpen: false,
      itemsPerRow: localStorage.getItem('itemsPerRow') || 'four',
      gridItemData: {
        two: 2,
        four: 4,
        eight: 8
      },
      gridItemDataMobile: {
        one: 1,
        two: 2,
        four: 4
      },
      itemsPerRowMobile: localStorage.getItem('itemsPerRowMobile') || 'one',
      svgTotalActiveInMobile: 0,
      totalSvgMobile: []
    }
  },
  computed: {
    isSortOpen () {
      return this.sortOpen ? 'visible' : 'hidden'
    },
    sortHeight () {
      return this.sortOpen ? '300px' : '0px'
    },
    gridClass () {
      return `collection__grid-${this.itemsPerRow}`
    },
    gridClassMobile () {
      return `collection__grid-mobile-${this.itemsPerRowMobile}`
    }
  },
  mounted () {
    Shopify.queryParams = {}

    if (location.search.length) {
      const params = new URLSearchParams(location.search)
      params.forEach((value, key) => {
        Shopify.queryParams[key] = value
      })
    }

    this.genrateSvgMobile()
    this.svgTotalActiveInMobile = this.gridItemDataMobile[this.itemsPerRowMobile] || 1

    const dropdown = document.querySelector('.view-pagination')

    const storedValue = localStorage.getItem('itemsPerRow')
    if (storedValue) {
      this.itemsPerRow = storedValue
    } else {
      this.itemsPerRow = dropdown.id
    }

    const dropdownMobile = document.querySelector('.view-pagination-mobile')
    const storedValueMobile = localStorage.getItem('itemsPerRowMobile')
    if (storedValueMobile) {
      this.itemsPerRowMobile = storedValueMobile
    } else {
      this.itemsPerRowMobile = dropdownMobile.id
    }

    if (Object.keys(Shopify.queryParams).length > 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToProductGrid()
        }, 500) // Delay to ensure page fully loads before scrolling
      })
    }
  },
  methods: {
    genrateSvgMobile () {
      this.totalSvgMobile = Object.values(this.gridItemDataMobile)
    },
    changeSvgGridMobile (value) {
      this.itemsPerRowMobile = this.getKeyByValueOrNext(value)
      this.svgTotalActiveInMobile = this.gridItemDataMobile[this.itemsPerRowMobile] || 1
    },
    getKeyByValueOrNext (value) {
      return (
        Object.keys(this.gridItemDataMobile).find(
          key => this.gridItemDataMobile[key] === value
        ) || Object.keys(this.gridItemDataMobile)[0]
      )
    },
    cycleView () {
      const keys = Object.keys(this.gridItemData)
      this.itemsPerRow = keys[(keys.indexOf(this.itemsPerRow) + 1) % keys.length]
    },
    cycleViewMobile () {
      const keys = Object.keys(this.gridItemDataMobile)
      this.itemsPerRowMobile = keys[(keys.indexOf(this.itemsPerRowMobile) + 1) % keys.length]
      this.svgTotalActiveInMobile = this.gridItemDataMobile[this.itemsPerRowMobile]
    },
    closeFilter () {
      this.filterOpen = false
      document.body.classList.remove('filter-open')
    },
    toggleFilter () {
      this.filterOpen = !this.filterOpen
      document.body.classList.toggle('filter-open', this.filterOpen)
    },
    toggleSort () {
      this.sortOpen = !this.sortOpen
    },
    applyFilters () {
      if (this.$refs.filterContent) {
        this.$refs.filterContent.submit()
      }
      this.scrollToProductGrid()
    },
    scrollToProductGrid () {
      this.$nextTick(() => {
        const productGrid = document.querySelector('#productGrid')
        if (productGrid) {
          window.scrollTo({
            top: productGrid.getBoundingClientRect().top + window.scrollY - 260,
            behavior: 'smooth'
          })
        }
      })
    },
    setSortDirection (e) {
      Shopify.queryParams.sort_by = e.target.value
      location.search = new URLSearchParams(Shopify.queryParams).toString()
      this.scrollToProductGrid()
    },
    changeItemsPerRow (e) {
      this.itemsPerRow = e.target.value
      localStorage.setItem('itemsPerRow', this.itemsPerRow)
      this.scrollToProductGrid()
    },
    changeItemsPerRowMobile (e) {
      this.itemsPerRowMobile = e.target.value
      localStorage.setItem('itemsPerRowMobile', this.itemsPerRowMobile)
      this.svgTotalActiveInMobile = this.gridItemDataMobile[this.itemsPerRowMobile] || 1
      this.scrollToProductGrid()
    }
  }
}))
